import { environment } from 'src/environments/environment';

export const COMMERCIAL_CATEGORIES_APIS_ENDPOINTS = {
  GET_COMMERCIAL_CATEGORIES_URL: `${environment.BACKEND_URL}api/commercial-categories/hierarchy`,
  GET_BOTTOM_LEVEL_CATEGORIES: `${environment.BACKEND_URL}api/commercial-categories/bottom-level`,
  GET_CATEGORY_DATA_BY_ID: (id: string): string =>
    `${environment.BACKEND_URL}api/commercial-categories/${id}`,
};
